import { useQuery } from '@tanstack/react-query';
import { getWetlandsData } from '../services/wetlands.ts';

export const useWetlandsData = (latitude: number, longitude: number) => {
  return useQuery({
    queryKey: ['wetlands', latitude, longitude],
    enabled: !!latitude && !!longitude,
    queryFn: ({ signal }) => {
      return getWetlandsData({ latitude, longitude, signal });
    },
  });
};
